import React from 'react'
import '../../../App.css'
import LeadershipLinks from '../LeadershipLinks';
import ImageComponent from '../../ImageComponent';

function MicahMonfrini() {
    return (
      <div className='bio-pages main-grid-container'>
      <div className='main-grid-item'>
    <LeadershipLinks/>
    </div>
          <div className='main narrow-grid'>
          <div className='bio-img-wrapper'>
          <ImageComponent src={require('../../../img/micah_monfrini_bio_portrait_1000px.jpg')}/>
          {/* <img src={require('../../../img/micah_monfrini_bio_portrait_1000px.jpg')} alt='larry loden portrait' /> */}
            </div>
            <h1 className='bio-header'>Micah Monfrini</h1>
            {/* <h2 className='bio-subheader'>Associate Pastor</h2> */}
            <p> 
            Micah Monfrini was born in central Texas and has lived here for most of his life. He was raised in the nurture and admonition of the Lord by faithful parents and was blessed to receive the gift of God’s salvation at a young age. After spending two years out of state in Seattle and Los Angeles pursuing a career in the video-game industry, Micah returned to Texas in 2014 and began attending Grace Community Fellowship.<br/><br/>
            After several years of growth and service to the body, he recognized God was calling him to full-time ministry. After nearly two years of preaching, teaching, and leading various ministries, he was ordained as an elder in November of 2023. As part of his continuing education, he is currently pursuing a Bachelor of Theology at The Master’s Seminary.<br/><br/>
            Micah and his wife Christina married in 2019 and have one daughter.
            </p>
          </div>
        </div>
      )
    }

export default MicahMonfrini
